// extracted by mini-css-extract-plugin
export default {"header":"qv","fullPage":"rv","closed":"sv","minimize":"tv","redcircle":"uv","container":"vv","text":"wv","centered":"xv","escapex":"yv"};
    if(module.hot) {
      // 1715276855779
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  